// src/utils.js

export function jsonToCsv(items, headers = null) {
  if (!items || items.length === 0) {
    return '';
  }
  const replacer = (key, value) => value === null ? '' : value;
  const header = headers || Object.keys(items[0]);
  const csv = [
    header.join(','),
    ...items.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
  ].join('\r\n');
  return csv;
}

export function downloadFile(content, fileName, mimeType) {
  const a = document.createElement('a');
  const blob = new Blob([content], { type: mimeType });
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(a.href);
}

// Shared constants
export const DIM_FIELDS = ['Mineral','Region','Country','Form','Input','Scenario', 'Type', 'Units', 'Year', 'Performer'];

export const DIM_KEY_MAP = {
  'Mine': 'source',
  'Intermediary': 'target',
  'Stage': 'stage',
  'Mineral': 'metal',
  'Year': 'year',
  'Country': 'country'
};
